import { FeedV2 } from "@fartherfinance/frontend/api/Notifications/Types";

import { NotificationsPath } from "@src/config/routing/RouterPaths";

type NotificationRedirectionURL = {
  url: string;
  isExternal: boolean;
};

export const resolveRedirectionUrl = (
  feed: FeedV2
): NotificationRedirectionURL | null => {
  const { url } = feed.data;

  if (url) {
    const isExternal = url.startsWith("http://") || url.startsWith("https://");

    return { url, isExternal };
  }

  if (feed.resourceType === "task") {
    return {
      url: `/Advisor/${NotificationsPath}/${feed.feedId}`,
      isExternal: false,
    };
  }

  return null;
};
